import { render, staticRenderFns } from "./MessagesToRead.vue?vue&type=template&id=648d5fc3&"
import script from "./MessagesToRead.vue?vue&type=script&lang=js&"
export * from "./MessagesToRead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports